import { useState, useEffect } from "react";
import apiParticipantes from "../api/Participantes/api-participantes";

export const useModalTipos = () => {
  const [codigoPropuesta, setCodigoPropuesta] = useState("");
  const [tipoP, settipoP] = useState("");
  const [numeroDocumento, setNumeroDocumento] = useState("");

  const actualizarCodigo = async () => {
    if (codigoPropuesta && numeroDocumento && tipoP) {
      let endCode = await apiParticipantes.actualizarTipoP(codigoPropuesta, numeroDocumento, tipoP)
      settipoP(endCode.data.tipoP)
    }
  };

  useEffect(() => {
  }, [tipoP]);

  return {
    actualizarCodigo,
    setCodigoPropuesta,
    codigoPropuesta,
    tipoP,
    settipoP,
    numeroDocumento,
    setNumeroDocumento
  };
};
